import { gql, GraphQLClient } from 'graphql-request'

import { AccessToken } from '../../../base/models/paramsModel'
import { MyGraphQlError } from '../../../base/services/GraphqlError'
import { TipoArticuloOrdenarInput } from '../interfaces'

const query = gql`
  mutation TIPO_ARTICULO_ORDENAR($input: [TipoArticuloOrdenarInput]!) {
    tipoArticuloOrdenar(input: $input)
  }
`

export const apiTipoArticuloOrdenar = async (input: TipoArticuloOrdenarInput[]): Promise<boolean> => {
  try {
    const client = new GraphQLClient(import.meta.env.ISI_API_URL)
    const token = localStorage.getItem(AccessToken)
    // Set a single header
    client.setHeader('authorization', `Bearer ${token}`)
    const data: any = await client.request(query, {
      input: input,
    })
    return data.tipoArticuloOrdenar
  } catch (e: any) {
    throw new MyGraphQlError(e)
  }
}
